export function initHeaderAnimations() {
  const headerFacts = document.querySelector('.landing-header-facts');
  if (!headerFacts) return;
  const headerFactsItems = [...document.querySelectorAll('.landing-header-facts .landing-header-fact')];


  function handleLandingHeaderAnimation() {
    const { animation } = headerFacts.dataset;
    if (window.innerWidth <= 540 && !animation) {
      headerFacts.setAttribute('data-animation', 'active');
      return;
    }
    if (window.innerWidth > 540) {
      headerFacts.removeAttribute('data-animation');
    }
  }

  const config = { attributes: true };
  let timer = null;


  function setActiveFact(index) {
    headerFactsItems.forEach((fact) => {
      fact.dataset.active = +fact.dataset.index === index;
      if (+fact.dataset.index === index) {
        const { width } = fact.getBoundingClientRect();
        headerFacts.scroll({ left: width * index, behavior: 'smooth', inline: 'start' })
      }
    });
  }

  function switchFact() {
    const activePost = Number(headerFactsItems.find((e) => e.dataset.active === 'true')?.dataset?.index) || 0;
    let nextFact = activePost + 1;
    if (activePost === headerFactsItems.length - 2) {
      nextFact = 0;
    }
    setActiveFact(nextFact);
  }

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        const { animation } = headerFacts.dataset;
        console.log(`The ${mutation.attributeName} attribute was modified. Current status: ${animation}`);
        if (animation) {
          timer = setInterval(() => switchFact(), 1000 * 5)
        } else {
          if (timer) this.clearInterval(timer);
          timer = null;
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(headerFacts, config);

  window.addEventListener('load', handleLandingHeaderAnimation);
  window.addEventListener('resize', handleLandingHeaderAnimation);
}